// extracted by mini-css-extract-plugin
export default {"root":"FilterBarFooter__root--t1ce8","showButton":"FilterBarFooter__showButton--ukOce"};